export default __webpack_public_path__ + "static/media/Fameye.7c266e7e.jpg";